import reducers from './reducers';
import Component from './index';
import sagas from './sagas';
import { NAME } from './constants';

export default {
  Component: Component,
  name: NAME,
  reducers,
  sagas,
};
